<template>
    <div class="containerRepresentante">
        <div class="title">
            <h3>Os campos com * são de preenchimento obrigatório</h3>
            <h5>Caso queira, você poderá salvar e continuar depois.</h5>
        </div>
        <div class="formulario">
            <div class="agrupamentoFormulario" style="border-bottom: 1px solid #D0D5DD;">
                <div class="categoriaAgrupamentoFormulario">
                    <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Administrador'" :TipoCliente="'Fundos'"
                        :Sessao="'Participantes'" :SubSessao="'Administrador'" />
                </div>
                <div class="camposAgrupamentoFormulario">
                    <div class="row">
                        <div class="label__field" style="width: 60%">
                            <label class="label" for="razaoSocial">Denominação social (sem abreviações)*</label>
                            <input class="field" type="text" @change="salvarAlteracoesLocalmenteParticipante"
                                v-model="participante.Administrador" id="razaoSocial">
                            <p v-if="camposObrigatorios.erroParticipanteAdministrador" class="erro">Campo obrigatório.
                            </p>
                        </div>
                        <div class="label__field" style="width: 40%">
                            <label class="label" for="cnpj">CNPJ*</label>
                            <input class="field" type="text" @change="salvarAlteracoesLocalmenteParticipante"
                                v-model="participante.AdministradorCnpj" id="cnpj" placeholder="00.000.000/0000-00">
                            <p v-if="camposObrigatorios.erroParticipanteAdministradorCnpj" class="erro">Campo
                                obrigatório.</p>
                        </div>
                    </div>
                    <div v-for="(representante, index) in representantes" :key="representante.Guid" class="empresaItem"
                        style="border-bottom: 1px solid #EAECF0;">
                        <div class="row" v-if="representante.Tipo == 'representanteAdministrador'">
                            <div class="label__field" style="width: 40%">
                                     <InputNome 
                                        v-model="representante.Nome"
                                        label="Representante legal"
                                        :required="true"
                                        :erro="camposObrigatoriosRepresentante[index]?.erroNome && tentativaPostagem"
                                        @blur="salvarAlteracoesLocalmenteRepresentante"
                                      />
                            </div>
                            <div class="label__field" style="width: 20%">
                                <label class="label" for="dataConstituicao">CPF*</label>
                                <input class="field" type="text" @change="salvarAlteracoesLocalmenteRepresentante"
                                    v-model="representante.CpfCnpj" id="cpfRepre" placeholder="000.000.000-00">
                                <p v-if="camposObrigatoriosRepresentante[index]?.erroCpfCnpj && tentativaPostagem"
                                    class="erro">Campo obrigatório.</p>
                            </div>
                            <div class="label__field" style="width: 20%">

                                <telefone-internacional 
                                    v-model="representante.Telefone" 
                                    label="Telefone" 
                                    :name="'TelefoneRepresentanteGestor_' + index"
                                    :opcional="true"
                                    @change="salvarAlteracoesLocalmenteRepresentante"
                                    @validate="onValidateTelefoneRepresentanteGestor"
                                />

                            </div>
                        </div>
                        <div class="row" v-if="representante.Tipo == 'representanteAdministrador'">
                            <div class="label__field" style="width: 40%">
                                <label class="label" for="dataConstituicao">E-mail</label>
                                <input class="field" :id="'emailRepresentante_' + index" type="text" @change="salvarAlteracoesLocalmenteRepresentante"
                                    v-model="representante.Email" @blur="validarEmailsRepresentanteAdmin(representante, index)">
                                <p v-if="emailErros['emailRepresentanteAdmin_' + index]" class="erro">{{ emailErros['emailRepresentanteAdmin_' + index] }}</p>

                            </div>
                            <div class="label__field" style="width: 20%">
                                <label class="label" for="dataConstituicao">Cargo</label>
                                <input class="field" type="text" @change="salvarAlteracoesLocalmenteRepresentante"
                                    v-model="representante.Cargo">
                            </div>
                        </div>
                        <div class="row" v-if="representante.Tipo == 'representanteAdministrador'">
                            <div class="label__field" style="width: 40%">
                                <label class="label" for="assinatura">Assinatura*</label>
                                <select id="assinante" class="field" @change="salvarAlteracoesLocalmenteRepresentante"
                                    v-model="representante.Assinatura">
                                    <option value="">Selecione</option>
                                    <option value="1">Não assina pela empresa</option>
                                    <option value="2">Assina isoladamente</option>
                                    <option value="0">Assina em conjunto</option>
                                </select>
                                <p v-if="camposObrigatoriosRepresentante[index]?.erroAssinatura && tentativaPostagem"
                                    class="erro">Campo obrigatório.</p>
                            </div>
                            <div class="label__field" v-if="index > 0" style="width: 5%; margin-top: 30px">
                                <a @click.stop.prevent="excluirRepresentante(index)" class="ico__delete"
                                    title="Excluir representante">
                                    <Icon icon="ico-delete" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="buttonsAcoes" style="margin-bottom: 10px;">
                        <button class="btnDefault" @click="addRepresentanteAdmin">+ Adicionar mais</button>
                    </div>
                </div>
            </div>
            <div class="agrupamentoFormulario" style="border-bottom: 1px solid #D0D5DD;">
                <div class="categoriaAgrupamentoFormulario">
                    <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Gestor'" :TipoCliente="'Fundos'"
                        :Sessao="'Participantes'" :SubSessao="'Gestor'" />
                </div>
                <div class="camposAgrupamentoFormulario">
                    <div class="row">
                        <div class="label__field" style="width: 60%">

                                    <InputNome 
                                        v-model="participante.Gestor"
                                        label="Denominação social ou Nome completo (sem abreviações)"
                                        :required="true"
                                        :erro="camposObrigatorios.erroParticipanteGestor"
                                        @blur="salvarAlteracoesLocalmenteParticipante"
                                    />
                            </div>

                        <div class="label__field" style="width: 40%">
                            <label class="label" for="cnpj">CNPJ/CPF*</label>
                            <input class="field" type="text" @change="salvarAlteracoesLocalmenteParticipante"
                                v-model="participante.GestorCnpj" id="cnpj" placeholder="00.000.000/0000-00">
                            <p v-if="camposObrigatorios.erroParticipanteGestorCnpj" class="erro">Campo obrigatório.</p>
                        </div>
                    </div>
                    <div v-for="(representante, index) in representantes" :key="representante.Guid" class="empresaItem"
                        style="border-bottom: 1px solid #EAECF0;">
                        <div class="row" v-if="representante.Tipo == 'gestor' || representante.Tipo == 'Gestor'">
                            <div class="label__field" style="width: 40%">

                                     <InputNome 
                                        v-model="representante.Nome"
                                        label="Representante legal"
                                        :required="true"
                                        :erro="camposObrigatoriosRepresentante[index]?.erroNome && tentativaPostagem"
                                        @blur="salvarAlteracoesLocalmenteParticipante"
                                    />


                            </div>
                            <div class="label__field" style="width: 20%">
                                <label class="label" for="dataConstituicao">CPF*</label>
                                <input class="field" type="text" @change="salvarAlteracoesLocalmenteRepresentante"
                                    v-model="representante.CpfCnpj" id="dataConstituicao" placeholder="000.000.000-00">
                                <p v-if="camposObrigatoriosRepresentante[index]?.erroCpfCnpj && tentativaPostagem"
                                    class="erro">Campo obrigatório.</p>
                            </div>
                            <div class="label__field" style="width: 20%">
                                
                                <telefone-internacional 
                                    v-model="representante.Telefone" 
                                    label="Telefone" 
                                    :name="'TelefoneRepresentanteGestor_' + index"
                                    :opcional="true"
                                    @change="salvarAlteracoesLocalmenteRepresentante"
                                    @validate="onValidateTelefoneRepresentanteGestor"
                                />

                            </div>
                        </div>
                        <div class="row" v-if="representante.Tipo == 'gestor' || representante.Tipo == 'Gestor'">
                            <div class="label__field" style="width: 40%">
                                <label class="label" for="dataConstituicao">E-mail</label>
                                <input class="field" type="text" :id="'emailRepresentanteGestor_' + index" @change="salvarAlteracoesLocalmenteRepresentante"
                                    v-model="representante.Email" @blur="validarEmailsRepresentanteGestor(representante, index)">

                                <p v-if="emailErros['emailRepresentanteGestor_' + index]" class="erro">{{ emailErros['emailRepresentanteGestor_' + index] }}</p>

                            </div>
                            <div class="label__field" style="width: 20%">
                                <label class="label" for="dataConstituicao">Cargo</label>
                                <input class="field" type="text" @change="salvarAlteracoesLocalmenteRepresentante"
                                    v-model="representante.Cargo">
                            </div>
                        </div>
                        <div class="row" v-if="representante.Tipo == 'gestor' || representante.Tipo == 'Gestor'">
                            <div class="label__field" style="width: 40%">
                                <label class="label" for="assinatura">Assinatura*</label>
                                <select id="assinante" class="field" @change="salvarAlteracoesLocalmenteRepresentante"
                                    v-model="representante.Assinatura">
                                    <option value="">Selecione</option>
                                    <option value="1">Não assina pela empresa</option>
                                    <option value="2">Assina isoladamente</option>
                                    <option value="0">Assina em conjunto</option>
                                </select>
                                <p v-if="camposObrigatoriosRepresentante[index]?.erroAssinatura && tentativaPostagem"
                                    class="erro">Campo obrigatório.</p>
                            </div>
                            <div class="label__field" v-if="index > 0" style="width: 5%; margin-top: 30px">
                                <a @click.stop.prevent="excluirRepresentante(index)" class="ico__delete"
                                    title="Excluir representante">
                                    <Icon icon="ico-delete" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="buttonsAcoes" style="margin-bottom: 10px;">
                        <button class="btnDefault" @click="addRepresentanteGestor">+ Adicionar mais</button>
                    </div>
                </div>
            </div>
            <div class="agrupamentoFormulario" style="border-bottom: 1px solid #D0D5DD;">
                <div class="categoriaAgrupamentoFormulario">
                    <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Emissor de Ordem'" :TipoCliente="'Fundos'"
                        :Sessao="'Participantes'" :SubSessao="'Emissor de Ordem'" />
                </div>
                <div class="camposAgrupamentoFormulario">
                    <div v-for="(emissorOrdem, index) in emissoresDeOrdens" :key="emissorOrdem.Guid" class="empresaItem"
                        style="  border-bottom: 1px solid #EAECF0;">
                        <div class="row">
                            <div class="label__field" style="width: 60%">

                                <InputNome 
                                        v-model="emissorOrdem.Nome"
                                        label="Representante legal"
                                        :required="true"
                                        :erro="camposObrigatoriosEmissor[index]?.erroNome && tentativaPostagem"
                                        @blur="salvarAlteracoesLocalmenteEmissorOrdem"
                                />



                            </div>
                            <div class="label__field" style="width: 40%">
                                <label class="label" for="cnpj">CNPJ/CPF*</label>
                                <input class="field" type="text" @change="salvarAlteracoesLocalmenteEmissorOrdem"
                                    v-model="emissorOrdem.CpfCnpj" id="cnpj" placeholder="00.000.000/0000-00">
                                <p v-if="camposObrigatoriosEmissor[index]?.erroCpfCnpj && tentativaPostagem"
                                    class="erro">Campo obrigatório.</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="label__field" style="width: 33%">
                                <label class="label" for="emailEmissorOrdem">E-mail*</label>
                                <input class="field" type="text" :id="'emailEmissorOrdem_' + index" @change="salvarAlteracoesLocalmenteEmissorOrdem"
                                    v-model="emissorOrdem.Email" @blur="validarEmailsEmissorOrdem(emissorOrdem, index)">

                                <p v-if="emailErros['emailEmissorOrdem_' + index]" 
                                class="erro">{{ emailErros['emailEmissorOrdem_' + index] }}</p>

                            </div>
                            <div class="label__field" style="width: 33%">

                                <telefone-internacional 
                                    v-model="emissorOrdem.Telefone" 
                                    label="Telefone*" 
                                    :name="'Telefone_' + index "
                                    @validate="onValidateTelefone"
                                    @change="salvarAlteracoesLocalmenteEmissorOrdem"
                                />

                                <p v-if="camposObrigatoriosEmissor[index]?.erroTelefone && !emissorOrdem.Telefone" class="erro">
                                    Telefone obrigatório ou inválido
                                </p>


                            </div>

                        </div>
                        <div class="row">
                            <div class="label__field" style="width: 20%">
                                <label class="label" for="dataConstituicao">Considerado US Person?</label>
                                <div class="radio">
                                    <input type="radio" :id="'UsPerson_Nao' + index" value="false"
                                        :name="'UsPerson_Nao' + index" class="field__radio"
                                        v-model="emissorOrdem.UsPerson"
                                        @change="salvarAlteracoesLocalmenteEmissorOrdem" />
                                    <label :for="'UsPerson_Nao' + index" class="label__radio">Não</label>
                                    <input type="radio" :id="'UsPerson_Sim' + index" value="true"
                                        :name="'UsPerson_Sim' + index" class="field__radio"
                                        v-model="emissorOrdem.UsPerson"
                                        @change="salvarAlteracoesLocalmenteEmissorOrdem" />
                                    <label :for="'UsPerson_Sim' + index" class="label__radio">Sim</label>
                                </div>
                            </div>
                            <div class="label__field" style="width: 20%">
                                <label class="label" for="dataConstituicao">Politicamente Exposto?</label>
                                <div class="radio">
                                    <input type="radio" :id="'PoliticamenteExposta_Nao' + index" value="false"
                                        :name="'PoliticamenteExposta_Nao' + index" class="field__radio"
                                        v-model="emissorOrdem.PoliticamenteExposta"
                                        @change="salvarAlteracoesLocalmenteEmissorOrdem" />
                                    <label :for="'PoliticamenteExposta_Nao' + index" class="label__radio">Não</label>
                                    <input type="radio" :id="'PoliticamenteExposta_Sim' + index" value="true"
                                        :name="'PoliticamenteExposta_Sim' + index" class="field__radio"
                                        v-model="emissorOrdem.PoliticamenteExposta"
                                        @change="salvarAlteracoesLocalmenteEmissorOrdem" />
                                    <label :for="'PoliticamenteExposta_Sim' + index" class="label__radio">Sim</label>
                                </div>
                            </div>
                            <div class="label__field" v-if="index > 0" style="width: 20%; margin-top: 30px">
                                <a @click.stop.prevent="excluirEmissorOrdem(index)" class="ico__delete"
                                    title="Excluir emissor de ordem">
                                    <Icon icon="ico-delete" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="buttonsAcoes" style="margin-bottom: 10px;">
                        <button class="btnDefault" @click="addEmisorOrdem">+ Adicionar mais</button>
                    </div>
                </div>
            </div>
            <div class="agrupamentoFormulario">
                <div class="categoriaAgrupamentoFormulario">
                    <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Custodiante'" :TipoCliente="'Fundos'"
                        :Sessao="'Participantes'" :SubSessao="'Custodiante'" />
                </div>
                <div class="camposAgrupamentoFormulario">
                    <div class="row">
                        <div class="label__field" style="width: 60%">

                                <InputNome 
                                    v-model="participante.Custodiante"
                                    label="Denominação social ou Nome completo (sem abreviações)"
                                    :required="true"
                                    :erro="camposObrigatorios.erroParticipanteCustodiante"
                                    @blur="salvarAlteracoesLocalmenteParticipante"
                                />
                        
                        </div>
                        <div class="label__field" style="width: 40%">
                            <label class="label" for="cnpj">CNPJ*</label>
                            <input class="field" type="text" @change="salvarAlteracoesLocalmenteParticipante"
                                v-model="participante.CustodianteCnpj" id="cnpj" placeholder="00.000.000/0000-00">
                            <p v-if="camposObrigatorios.erroParticipanteCustodianteCnpj" class="erro">Campo obrigatório.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 30%">
                            <label class="label" for="cpf">Código CBLC</label>
                            <input class="field" type="text" @change="salvarAlteracoesLocalmenteParticipante"
                                v-model="participante.CustodianteCBLC" id="representanteLegal">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="formularioOutrosParticipantes">
            <div class="titleForm" style="display: inline-flex; width: 100%">
                <div v-if="!listaRepresentantes?.length > 0" style="width: 100%">
                    <LabelDisclaimer :TamanhoFonteLabel="'H3'" :NomeLabel="'Outros participantes'"
                        :TipoCliente="'Fundos'" :Sessao="'Participantes'" :SubSessao="'Outros participantes'" />
                    <h5>Clique em adicionar e selecione entre as opções: Diretor ou Administrador.</h5>
                </div>
                <div v-if="listaRepresentantes?.length > 0" style="width: 90%">
                    <h3>Outros participantes</h3>
                    <h5>Clique em adicionar e selecione entre as opções Diretor ou Administrador.</h5>
                </div>
                <div v-if="listaRepresentantes?.length > 0" style="width: 5%; margin-top: 40px;">
                    <button class="btnBlue" @click="addParticipante()">+ Adicionar</button>
                </div>
            </div>
            <div class="titleForm">
                <div class="opcoesForm" v-if="!listaRepresentantes?.length > 0" style="margin-bottom: 10px">
                    <img src="@/assets/addRepresentante.png" />
                    <h3>Nenhum participante adicionado</h3>
                    <h5>Clique em adicionar e selecione entre as opções Diretor ou Administrador.</h5>
                    <button class="btnBlue" @click="addParticipante()">+ Adicionar</button>
                </div>
                <div v-if="listaRepresentantes?.length > 0">
                    <table class="table">
                        <thead>
                            <th style="width: 20%">Nome</th>
                            <th style="width: 11%">Tipo</th>
                            <th style="width: 15%">CPF/CNPJ</th>
                            <th style="width: 15%">Telefone</th>
                            <th style="width: 15%">E-mail</th>
                            <th style="width: 14%">Assinatura</th>
                            <th style="width: 10%">&nbsp;</th>
                        </thead>
                        <tbody>
                            <tr v-for="(representanteObj, index) in listaRepresentantes" :key="index">
                                <td>{{ representanteObj.Nome }}</td>
                                <td>{{ representanteObj.Tipo }}</td>
                                <td>{{ formatCpfCnpj(representanteObj.CpfCnpj) }}</td>
                                <td>{{ representanteObj.Telefone }}</td>
                                <td>{{ representanteObj.Email }}</td>
                                <td>{{ representanteObj.AssinaturaFormatada }}</td>
                                <td>
                                    <div class="widget icons" style="display: inline-flex">
                                        <a @click.stop.prevent="editarParticipante(index)" class="ico__edit"
                                            title="editar">
                                            <Icon icon="ico-edit" />
                                        </a>
                                        <a @click.stop.prevent="excluirParticipante(index)" class="ico__delete"
                                            title="deletar" style="margin-left: 5px"></a>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <ModalAddParticipante />
    </div>
</template>

<script>

import { mapGetters } from 'vuex';
import emailValidatorMixin from '@/utils/emailValidatorMixin.js';
import api from '@/api/axios';
import formatCpfCnpj from '@/utils/formatCpfCnpj'
import ModalAddParticipante from './ModalAddParticipante.vue'
import LabelDisclaimer from '@/components/LabelDisclaimer.vue'
import { makeSnapshot, hasChanges } from "@/utils/dirtyTracker";

import { confirmarReassinatura } from "@/utils/confirmarReassinatura";
import { verificarDocumentoAtivo } from "@/utils/verificarDocumentoAtivo";

export default {
    name: 'CadastroOutros_Participantes',
    mixins: [formatCpfCnpj, emailValidatorMixin],
    props: ['informacoesParticipantes', 'Edicao', 'emissoresDeOrdensBD'],
    components: { ModalAddParticipante, LabelDisclaimer },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            listaRepresentantes: 'GET_LISTA_PARTICIPANTES_FI',
            listaDeRepresentantes: 'GET_FI_INFO_PARTICIPANTE_REPRESENTANTE',
        }),
    },
    data() {
        return {
            permitirAvancar: false,
            telefoneValido: [],
            telefoneRepresentanteGestorValido: [],
            emailErros: {},
            camposObrigatorios: {
                erroParticipanteAdministrador: false,
                erroParticipanteAdministradorCnpj: false,
                erroParticipanteGestor: false,
                erroParticipanteGestorCnpj: false,
                erroParticipanteCustodiante: false,
                erroParticipanteCustodianteCnpj: false,
            },
            //camposObrigatoriosRepresentante: [],
            camposObrigatoriosRepresentante: [{
                erroNome: false,
                erroCnpj: false,
                erroAssinatura: false
            }],
            //camposObrigatoriosGestor: [],
            camposObrigatoriosEmissor: [],
            participante: this.informacoesParticipantes,
            informacoesParticipantesRepresentantes: this.listaDeRepresentantes,
            representantes: [],
            emissoresDeOrdens: [],
            nomeRepresentante: {
                Guid: '',
                Nome: '',
                CpfCnpj: '',
                Tipo: '',
                Email: '',
                Cargo: '',
                Telefone: ''
            },
        }
    },
    mounted() {
        this.$store.commit('SET_MODAL_FI_ADD_PARTICIPANTE', false);
        this.$store.dispatch('FETCH_FI_INFO_PARTICIPANTE_REPRESENTANTE');
        this.informacoesParticipantesRepresentantes = this.listaDeRepresentantes;
        var possuiGestor = this.informacoesParticipantesRepresentantes.some(representante => representante.Tipo === 'gestor' || representante.Tipo == "Gestor");
        var possuiAdministrador = this.informacoesParticipantesRepresentantes.some(representante => representante.Tipo === 'representanteAdministrador');
        var possuiEmissorOrdem = this.emissoresDeOrdensBD.length > 0 ? true : false;
        this.emissoresDeOrdens = this.emissoresDeOrdensBD;
        if (!possuiEmissorOrdem) {
            this.addEmisorOrdem();
        }
        if (possuiGestor && possuiAdministrador) {
            this.representantes = this.informacoesParticipantesRepresentantes;
        } else {
            if (!possuiGestor && !possuiAdministrador) {
                this.addRepresentanteGestor();
                this.addRepresentanteAdmin();
            }
            if (!possuiGestor) {
                this.representantes = this.informacoesParticipantesRepresentantes;
                this.addRepresentanteGestor();
            }
            if (!possuiAdministrador) {
                this.representantes = this.informacoesParticipantesRepresentantes;
                this.addRepresentanteAdmin();
            }
        }

        this.inicializarCamposObrigatoriosRepresentante();
        this.inicializarCamposObrigatoriosEmissor();

        this._repSnap = makeSnapshot(this.representantes);

    },
    watch: {
        listaDeRepresentantes() {
            this.informacoesParticipantesRepresentantes = this.listaDeRepresentantes;
            var possuiGestor = this.informacoesParticipantesRepresentantes.some(representante => representante.Tipo === 'gestor' || representante.Tipo == "Gestor");
            var possuiAdministrador = this.informacoesParticipantesRepresentantes.some(representante => representante.Tipo === 'representanteAdministrador');
            var possuiEmissorOrdem = this.emissoresDeOrdensBD.length > 0 ? true : false;
            this.emissoresDeOrdens = this.emissoresDeOrdensBD;
            if (!possuiEmissorOrdem) {
                this.addEmisorOrdem();
            }
            if (possuiGestor && possuiAdministrador) {
                this.representantes = this.informacoesParticipantesRepresentantes;
            } else {
                if (!possuiGestor && !possuiAdministrador) {
                    this.addRepresentanteGestor();
                    this.addRepresentanteAdmin();
                }
                if (!possuiGestor) {
                    this.representantes = this.informacoesParticipantesRepresentantes;
                    this.addRepresentanteGestor();
                }
                if (!possuiAdministrador) {
                    this.representantes = this.informacoesParticipantesRepresentantes;
                    this.addRepresentanteAdmin();
                }
            }
        },
        representantes: {
            handler(newRepresentante) {
                this.camposObrigatoriosRepresentante = newRepresentante.map(() => ({
                    erroNome: false,
                    erroCnpj: false,
                    erroAssinatura: false
                }));
            },
            immediate: true
        },
        emissoresDeOrdens: {
            handler(newEmissoresDeOrdens) {
                this.camposObrigatoriosEmissor = newEmissoresDeOrdens.map(() => ({
                    erroNome: false,
                    erroCnpj: false,
                    erroEmail: false,
                    erroTelefone: false
                }));
            },
            immediate: true
        }
    },
    methods: {
        houveAlteracaoRepresentantesCriticos() {
            return hasChanges(this.representantes, this._repSnap);
        },
        onValidateTelefone({ name, valid }) {
            if (!this.telefoneValido) {
                this.telefoneValido = {};
            }
            if(valid != 'undefined'){
                this.telefoneValido[name] = valid;
            }
        },
        onValidateTelefoneGestor({ name, valid }) {
            if (!this.telefoneSocioValido) {
                this.telefoneGestorValido = {};
            }
            if(valid != 'undefined'){
                this.telefoneGestorValido[name] = valid;
            }
        },
        onValidateTelefoneRepresentanteGestor({ name, valid }) {
            if (!this.telefoneSocioValido) {
                this.telefoneRepresentanteGestorValido = {};
            }
            if(valid != 'undefined'){
                this.telefoneRepresentanteGestorValido[name] = valid;
            }
        },
        validarEmailsRepresentanteAdmin(representante, index) {
            const fieldId = 'emailRepresentanteAdmin_' + index;
            
            this.validarEmailGeneric(representante.Email, fieldId, {
                obrigatorio: true,
                mensagemObrigatorio: 'Campo obrigatório.'
            });
        },
        validarEmailsRepresentanteGestor(representante, index) {
            const fieldId = 'emailRepresentanteGestor_' + index;
            
            this.validarEmailGeneric(representante.Email, fieldId, {
                obrigatorio: false
            });
        },
        validarEmailsEmissorOrdem(representante, index) {
            const fieldId = 'emailEmissorOrdem_' + index;
            
            this.validarEmailGeneric(representante.Email, fieldId, {
                obrigatorio: true,
                mensagemObrigatorio: 'Campo obrigatório.'
            });
        },
        addParticipante() {
            this.$store.commit('SET_MODAL_FI_EDITAR_PARTICIPANTE', null);
            this.$store.commit('SET_MODAL_FI_ADD_PARTICIPANTE', true);
        },
        editarParticipante(index) {
            this.$store.commit('SET_MODAL_FI_EDITAR_PARTICIPANTE', this.listaRepresentantes[index]);
            this.$store.commit('SET_MODAL_FI_ADD_PARTICIPANTE', true);
        },
        async excluirEmissorOrdem(index) {
             
            if (this.emissoresDeOrdens[index].Guid == '') {
                this.emissoresDeOrdens.splice(index, 1);
                this.$store.commit('SET_FI_SALVAR_INFO_EMISSOR_ORDEM', this.emissoresDeOrdens);
                this.$swal({
                    icon: 'success',
                    title: 'Exclusão realizada com sucesso!',
                    text: 'Dados informados foram excluídos com sucesso.',
                });
                return;
            }
            await api.get(`fundo/pessoaAutorizadaEmitirOrdem/excluir?guid=${this.emissoresDeOrdens[index].Guid}`)
                .then((retorno) => {
                    if (retorno.status == 200) {
                        this.$swal({
                            icon: 'success',
                            title: 'Exclusão realizada com sucesso!',
                            text: 'Dados informados foram excluídos com sucesso.',
                        });
                        this.$store.dispatch('FETCH_FI_INFO_EMISSOR_ORDEM');
                    }
                })
                .catch((error) => {
                    this.$swal({
                        icon: 'error',
                        title: 'Dados informados inválidos.',
                        text: `${error.response.data.data[0]}`,
                    });
                });
        },
        async excluirParticipante(index) {
             
            await api.get(`fundo/emissorOrdem/excluir?guid=${this.listaRepresentantes[index].Guid}`)
                .then((retorno) => {
                    if (retorno.status == 200) {
                        this.$swal({
                            icon: 'success',
                            title: 'Exclusão realizada com sucesso!',
                            text: 'Dados informados foram excluídos com sucesso.',
                        });
                        this.$store.dispatch('FETCH_FI_INFO_PARTICIPANTE_CUSTODIANTE');
                        this.validarFormulario();
                    }
                })
                .catch((error) => {
                    this.$swal({
                        icon: 'error',
                        title: 'Dados informados inválidos.',
                        text: `${error.response.data.data[0]}`,
                    });
                });
        },
        async proximaEtapa() {
            if (await this.validarFormulario(true)) {
                this.$store.commit('SET_FI_SALVAR_INFO', true);
                this.$store.commit('SET_SALVAR_INFO_DES_NOTIFICACAO', true);                
                this.$store.commit('SET_ETAPA_CADASTRO', 3);
            }
        },
        async validarFormulario(submeter) {
            this.permitirAvancar = true;
            var valorInvalido = false;
            this.tentativaPostagem = submeter;
            var nomeDoCampo = '';
            this.camposObrigatorios = {
                erroParticipanteAdministrador: false,
                erroParticipanteAdministradorCnpj: false,
                erroParticipanteGestor: false,
                erroParticipanteGestorCnpj: false,
                erroParticipanteCustodiante: false,
                erroParticipanteCustodianteCnpj: false,
            };
            let continuar = true;
            if (!this.participante.Administrador) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroParticipanteAdministrador = true;
                    nomeDoCampo = 'Denominação social do Administrador';
                }
                this.permitirAvancar = false;
                continuar = false;
            }
            if (continuar && !this.participante.AdministradorCnpj) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroParticipanteAdministradorCnpj = true;
                    nomeDoCampo = 'CNPJ do Administrador';
                }
                this.permitirAvancar = false;
                continuar = false;
            }
            if (continuar) {
                for (let index = 0; index < this.representantes.length; index++) {
                    const obj = this.representantes[index];
                    if (!obj.Nome) {
                        this.camposObrigatoriosRepresentante[index].erroNome = true;
                        this.permitirAvancar = false;
                        if (submeter && nomeDoCampo === '') {
                            nomeDoCampo = 'Nome do ' + (obj.Tipo == 'representanteAdministrador' ? 'representante legal do Administrador' : 'representante legal do Gestor');
                        }
                        continuar = false;
                        break;
                    } else {
                        this.camposObrigatoriosRepresentante[index].erroNome = false;
                    }
                    if (!obj.CpfCnpj) {
                        this.camposObrigatoriosRepresentante[index].erroCnpj = true;
                        this.permitirAvancar = false;
                        if (submeter && nomeDoCampo === '') {
                            nomeDoCampo = 'CPF do ' + (obj.Tipo == 'representanteAdministrador' ? 'representante legal do Administrador' : 'representante legal do Gestor');
                        }
                        continuar = false;
                        break;
                    } else {
                        this.camposObrigatoriosRepresentante[index].erroCnpj = false;
                    }
                    if (obj.Assinatura === null || obj.Assinatura === undefined || obj.Assinatura === '') {
                        this.camposObrigatoriosRepresentante[index].erroAssinatura = true;
                        this.permitirAvancar = false;
                        if (submeter && nomeDoCampo === '') {
                            nomeDoCampo = 'Assinatura do ' + (obj.Tipo == 'representanteAdministrador' ? 'representante legal do Administrador' : 'representante legal do Gestor');
                        }
                        continuar = false;
                        break;
                    } else {
                        this.camposObrigatoriosRepresentante[index].erroAssinatura = false;
                    }

                     const telefoneRepresentanteGestorValido = this.telefoneRepresentanteGestorValido[`TelefoneRepresentanteGestor_${index}`];


                    if (obj.Telefone.length > 4 && (!obj.Telefone || telefoneRepresentanteGestorValido == false)) {
                    if (submeter && this.permitirAvancar) {
                        this.camposObrigatoriosRepresentante[index].erroTelefone = true;
                        nomeDoCampo = 'Telefone do ' + (obj.Tipo == 'representanteAdministrador' ? 'representante legal do Administrador' : 'representante legal do Gestor');
                    }
                        if(telefoneRepresentanteGestorValido== false){
                            valorInvalido = true;
                        }
                        this.permitirAvancar = false;
                        continuar = false;
                        break;
                    }else{
                        this.camposObrigatoriosRepresentante[index].erroTelefone = false;
                    }



                    if (this.temErrosEmailPorPrefixo('emailRepresentanteAdmin_') && obj.Tipo == 'representanteAdministrador' || this.temErrosEmailPorPrefixo('emailRepresentanteGestor') && obj.Tipo != 'representanteAdministrador') {
                        this.permitirAvancar = false;
                        if (submeter && nomeDoCampo === '') {
                            nomeDoCampo = 'e-mail do ' + (obj.Tipo == 'representanteAdministrador' ? 'representante legal do Administrador' : 'representante legal do Gestor');
                        }
                        continuar = false;
                        break;
                    }

                }
            }
            if (continuar && !this.participante.Gestor) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroParticipanteGestor = true;
                    nomeDoCampo = 'Denominação social ou Nome completo do Gestor';
                }
                this.permitirAvancar = false;
                continuar = false;
            }
            if (continuar && !this.participante.GestorCnpj) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroParticipanteGestorCnpj = true;
                    nomeDoCampo = 'CNPJ do Gestor';
                }
                this.permitirAvancar = false;
                continuar = false;
            }
            if (continuar) {
                for (let index = 0; index < this.emissoresDeOrdens.length; index++) {
                    const obj = this.emissoresDeOrdens[index];
                    if (!obj.Nome) {
                        this.camposObrigatoriosEmissor[index].erroNome = true;
                        this.permitirAvancar = false;
                        if (submeter && nomeDoCampo === '') nomeDoCampo = 'Nome do Emissor de Ordem';
                        continuar = false;
                        break;
                    } else {
                        this.camposObrigatoriosEmissor[index].erroNome = false;
                    }
                    if (!obj.CpfCnpj) {
                        this.camposObrigatoriosEmissor[index].erroCpfCnpj = true;
                        this.permitirAvancar = false;
                        if (submeter && nomeDoCampo === '') nomeDoCampo = 'CNPJ do Emissor de Ordem';
                        continuar = false;
                        break;
                    } else {
                        this.camposObrigatoriosEmissor[index].erroCpfCnpj = false;
                    }

                    const telefoneValido = this.telefoneValido[`Telefone_${index}`];

                    if (!obj.Telefone || telefoneValido == false) {
                    if (submeter && this.permitirAvancar) {
                        this.camposObrigatoriosEmissor[index].erroTelefone = true;
                        nomeDoCampo = 'Telefone do Emissor de Ordem';
                    }
                        if(telefoneValido == false){
                            valorInvalido = true;
                        }
                        this.permitirAvancar = false;
                        continuar = false;
                        break;
                    }else{
                        this.camposObrigatoriosEmissor[index].erroTelefone = false;
                    }



                    if (this.temErrosEmailPorPrefixo('emailRepresentanteGestor_')) {
                        this.permitirAvancar = false;
                        if (submeter && nomeDoCampo === '') {
                            nomeDoCampo = 'e-mail do Emissor de ordem';
                        }
                        continuar = false;
                        break;
                    }

                }
            }
            if (continuar && !this.participante.Custodiante) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroParticipanteCustodiante = true;
                    nomeDoCampo = 'Denominação social ou Nome completo do Custodiante';
                }
                this.permitirAvancar = false;
                continuar = false;
            }
            if (continuar && !this.participante.CustodianteCnpj) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroParticipanteCustodianteCnpj = true;
                    nomeDoCampo = 'CNPJ do Custodiante';
                }
                this.permitirAvancar = false;
                continuar = false;
            }
            if (submeter && nomeDoCampo != '') {
                if(valorInvalido){

                    this.$swal({
                        icon: 'warning',
                        title: 'Oops...',
                        text: `O campo ` + nomeDoCampo + ` foi informado, mas não foi preenchido corretamente. Preencha a informação para avançar.`,
                    });

                }else{

                    this.$swal({
                        icon: 'warning',
                        title: 'Oops...',
                        text: `O campo ` + nomeDoCampo + ` não foi informado ou é inválido, preencha a informação para avançar.`,
                    });

                }
            }
            else if(submeter){
                if (this.houveAlteracaoRepresentantesCriticos()) {
                       var documentoAtivo = await verificarDocumentoAtivo();
                    if (documentoAtivo) {
                        var confirmado = await confirmarReassinatura();
                        if (!confirmado){ 
                            this.permitirAvancar = false;
                            return false;
                        }
                    }
                }
            }
            return this.permitirAvancar;
        },
        temErrosEmailPorPrefixo(prefixo) {
            return Object.keys(this.emailErros)
                .filter(key => key.startsWith(prefixo))
                .some(key => this.emailErros[key] !== '');
        },
        async salvarInformacoes() {

            if (this.houveAlteracaoRepresentantesCriticos()) {
                var documentoAtivo = await verificarDocumentoAtivo();

                if (documentoAtivo) {
                    var confirmado = await confirmarReassinatura();
                    if (!confirmado){ 
                        return false;
                    }
                }
            }

            this.$store.commit('SET_FI_SALVAR_INFO', true);
            this._repSnap = makeSnapshot(this.representantes);
        },
        salvarAlteracoesLocalmenteParticipante() {
            this.$store.commit('SET_FI_SALVAR_INFO_PARTICIPANTE', this.participante);
            //this.validarFormulario();
        },
        salvarAlteracoesLocalmenteRepresentante() {
            this.$store.commit('SET_FI_SALVAR_INFO_PARTICIPANTE_REPRESENTANTE', this.representantes);
            //this.validarFormulario();
        },
        salvarAlteracoesLocalmenteEmissorOrdem() {
            this.$store.commit('SET_FI_SALVAR_INFO_EMISSOR_ORDEM', this.emissoresDeOrdens);
            //this.validarFormulario();
        },
        addEmisorOrdem() {
            this.emissor = { Guid: '', Nome: '', CpfCnpj: '', Telefone: '', Email: '', Cargo: '', UsPerson: "false", PoliticamenteExposta: "false" };
            this.emissoresDeOrdens.push({ ...this.emissor });
            if (!this.camposObrigatoriosEmissor) this.camposObrigatoriosEmissor = [];
            this.camposObrigatoriosEmissor.push({
                erroNome: false,
                erroCpfCnpj: false,
                erroEmail: false,
                erroTelefone: false
            });
        },
        addRepresentanteGestor() {
            this.novoRepresentante = { Guid: '', Nome: '', CpfCnpj: '', Tipo: 'gestor', Telefone: '', Email: '', Cargo: '', Signatario: "false", Assinatura: '' };
            this.representantes.push({ ...this.novoRepresentante });
            if (!this.camposObrigatoriosRepresentante) this.camposObrigatoriosRepresentante = [];
            this.camposObrigatoriosRepresentante.push({
                erroNome: false,
                erroCpfCnpj: false,
                erroAssinatura: false
            });
        },
        addRepresentanteAdmin() {
            this.novoRepresentante = { Guid: '', Nome: '', CpfCnpj: '', Tipo: 'representanteAdministrador', Telefone: '', Email: '', Cargo: '', Signatario: "false", Assinatura: '' };
            this.representantes.push({ ...this.novoRepresentante });
            if (!this.camposObrigatoriosRepresentante) this.camposObrigatoriosRepresentante = [];
            this.camposObrigatoriosRepresentante.push({
                erroNome: false,
                erroCpfCnpj: false,
                erroAssinatura: false
            });
        },
        async excluirRepresentante(index) {
             
             if(this.representantes[index].Assinatura != '1'){
                var documentoAtivo = await verificarDocumentoAtivo();

                if (documentoAtivo) {
                    var confirmado = await confirmarReassinatura();
                    if (!confirmado){ 
                        return false;
                    }
                }
             }

            if (this.representantes[index].Guid == '') {
                this.representantes.splice(index, 1);
                this.$store.commit('SET_FI_SALVAR_INFO_PARTICIPANTE_REPRESENTANTE', this.representantes);
                await this.validarFormulario();
            } else {
                await api.get(`fundo/representante/excluir?guid=${this.representantes[index].Guid}&tipo=${this.representantes[index].Tipo}`)
                    .then((retorno) => {
                        if (retorno.status == 200) {
                            this.validarFormulario();
                            this.$swal({
                                icon: 'success',
                                title: 'Exclusão realizada com sucesso!',
                                text: 'Dados informados foram excluídos com sucesso.',
                            });
                            this.representantes.splice(index, 1);
                            this._repSnap = makeSnapshot(this.representantes);
                            this.$store.commit('SET_FI_SALVAR_INFO_PARTICIPANTE_REPRESENTANTE', this.representantes);
                        }
                    })
                    .catch((error) => {
                        this.$swal({
                            icon: 'error',
                            title: 'Dados informados inválidos.',
                            text: `${error.response.data.data[0]}`,
                        });
                    });
            }
        },
        inicializarCamposObrigatoriosRepresentante() {
            this.camposObrigatoriosRepresentante = this.representantes.map(() => ({
                erroNome: false,
                erroCpfCnpj: false,
                erroAssinatura: false
            }));
        },
        inicializarCamposObrigatoriosEmissor() {
            this.camposObrigatoriosEmissor = this.emissoresDeOrdens.map(() => ({
                erroNome: false,
                erroCpfCnpj: false,
                erroTelefone: false,
                erroEmail: false
            }));
        }
    }
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

.field__radio {
    margin-top: -2px;
    width: 20px;
    height: 20px;
}

// .btnBlue {
//     height: 40px;
//     font-family: 'Inter', sans-serif;
//     /* Fonte Inter */
//     background-color: #00235C;
//     color: white;
//     border: 1px solid #00235C;
//     /* Borda */
//     border-radius: 8px;
//     /* Raio de borda */
//     width: 100px;
//     cursor: pointer;
// }

// .formulario {
//     width: 100%;
// }

// .btnBlueUpload {
//     height: 40px;
//     font-family: 'Inter', sans-serif;
//     /* Fonte Inter */
//     background-color: #00235C;
//     border: 1px solid #00235C;
//     /* Borda */
//     border-radius: 8px;
//     /* Raio de borda */
//     widows: 88px;
//     cursor: pointer;
// }

// .formularioOutrosParticipantes {
//     margin-top: 20px;
//     width: 100%;
//     margin-bottom: 10px;
//     font-family: 'Inter', sans-serif;
//     /* Fonte Inter */
//     border: 1px solid #EAECF0;
//     border-radius: 8px;
//     /* Raio de borda */

//     .titleForm {
//         background-color: white;
//         border-bottom: 1px solid #EAECF0;

//         h3 {
//             margin-left: 20px;
//             color: #101828;
//             font-weight: 500;
//             font-family: 'Inter', sans-serif;
//         }

//         h5 {
//             margin-top: 5px;
//             margin-left: 20px;
//             margin-block-start: 0;
//             color: #667085;
//             font-weight: 500;
//             font-family: 'Inter', sans-serif;
//         }
//     }

//     .resumoForm {
//         width: 100%;

//         .opcoesForm {
//             margin-left: 30%;
//             display: grid;
//             justify-content: space-between;
//             align-content: space-between;
//             align-items: center;
//             justify-items: center;

//             h5 {
//                 margin-top: 5px;
//                 margin-block-start: 0;
//                 color: #667085;
//                 font-weight: 500;
//                 font-family: 'Inter', sans-serif;
//             }

//             img {
//                 height: 48px;
//                 width: 48px;

//             }

//             .btnBlue {
//                 height: 40px;
//                 font-family: 'Inter', sans-serif;
//                 /* Fonte Inter */
//                 background-color: #00235C;
//                 color: white;
//                 border: 1px solid #00235C;
//                 /* Borda */
//                 border-radius: 8px;
//                 /* Raio de borda */
//                 width: 350px;
//                 cursor: pointer;
//             }
//         }
//     }
// }

// .agrupamentoFormulario {
//     width: 100%;
//     display: inline-flex;
//     margin-top: 10px;
//     /* Borda */
// }

// .categoriaAgrupamentoFormulario {
//     width: 13%;
//     margin-right: 15px;
//     font-family: 'Inter', sans-serif;
//     /* Fonte Inter */

//     span {
//         font-weight: 400 !important;
//         font-size: 13px;
//         color: #667085;
//     }
// }

// .label__field {
//     padding-right: 30px;
// }

// .camposAgrupamentoFormulario {
//     width: 90%;

//     .row {
//         width: 100%;
//         display: inline-flex;
//         gap: 8px;
//         margin-bottom: 10px;
//     }

//     .accept {
//         display: inline-flex;
//         &:checked {
//             +label {
//                 &:before {
//                     background: white;
//                     border: 1px solid black;
//                     transition: background 0.3s;
//                 }
//             }
//             +label {
//                 &::after {
//                     opacity: 1;
//                     transition: all;
//                     background: transparent;
//                 }
//             }
//         }
//     }

//     .radio {
//         display: flex;
//         align-items: center;
//         margin-right: 25px;
//         @media (max-width: 768px) {
//             margin-right: 0;
//             margin-bottom: 20px;
//         }

//         .field__radio {
//             width: 20px;
//             height: 20px;
//         }

//         .fieldInRadio {
//             border-radius: 8px;
//             /* Raio de borda */
//             border: 1px solid #D0D5DD;
//             /* Borda */
//             padding: 10px 14px;
//             /* Preenchimento interno */
//             background-color: #F9FAFB;
//             /* Cor de fundo */
//             width: 55%;
//         }

//         .label__radio {
//             margin-left: 5px;
//             margin-right: 40px;
//             margin-top: 5px;
//         }
//     }

//     select {
//         width: 105% !important;
//     }

//     label {
//         font-family: 'Inter', sans-serif;
//         /* Fonte Inter */
//         font-weight: 500;
//         /* Peso médio */
//         font-size: 14px;
//         /* Tamanho da fonte */
//         line-height: 20px;
//         /* Altura da linha */
//         color: #344054;
//         /* Cor */
//         display: block;
//         /* Garante que a label fique acima do input */
//         margin-bottom: 8px;
//         /* Espaçamento entre a label e o input abaixo dela */
//     }
// }





// .title {

//     border-bottom: 1px solid #EAECF0;

//     h3 {
//         margin-top: 50px;
//         color: #101828;
//         font-weight: 500;
//         font-family: 'Inter', sans-serif;

//     }

//     h5 {
//         margin-top: 5px;
//         margin-block-start: 0;
//         color: #667085;
//         font-weight: 400;
//         font-family: 'Inter', sans-serif;
//     }
// }</style>